import React from 'react';

import AdminSurveyTemplateListContainer from '@src/components/administration/AdminSurveyTemplateListContainer';

const AdminSurveyTemplateListPage = () => <AdminSurveyTemplateListContainer />;

export default AdminSurveyTemplateListPage;
